import {Typography} from "@material-ui/core";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import PropTypes from "prop-types";
import ActivationRequestStep from "./activation-request-step/activation-request/ActivationRequestStep";
import GenericDialog from "../../../../../../../../ui/dialogs/generic-dialog/GenericDialog";
import ActivationRequestStepActions from "./activation-request-step/ActivationRequestStepActions";
import ActivationSummaryStep from "./activation-request-step/activation-summary/ActivationSummaryStep";
import {getConsipPlan} from "../../../../../../../../../store/ordini-consip/actions";
import {useParams} from "react-router-dom";
import ActivationConfirmStep from "./activation-request-step/activation-confirm-step/ActivationConfirmStep";
import ActivationConfirmStepAction from "./activation-request-step/activation-confirm-step/ActivationConfirmStepAction";
import {resetReportResponse} from "../../../../../../../../../store";
import QuantitaSuperataDialog from "./quantita-superata-dialog/QuantitaSuperataDialog";

const AttivaSimDialog = ({open, handleDialogClose, selectedSims}) => {
    const dispatch = useDispatch()
    const {consipId} = useParams()
    const integrationId = useSelector(state => state.authReducer.selectedCompany.integrationId)
    const [step, setStep] = useState(0)
    const [values, setValues] = useState({
        serviceType: '',
        planType: '',
    })
    const planOptions = useSelector(state => state.ordiniConsipReducer.consipPlans.data)
    const [qtaSuperataOpen, setQtaSuperataOpen] = useState(false)

    const handleSetStep = (stepValue) => {
        setStep(stepValue);
    }

    useEffect(() => {
        if (values.serviceType !== '') {
            dispatch(getConsipPlan(integrationId, consipId, values.serviceType, selectedSims))
        }
    }, [dispatch, values.serviceType, consipId, integrationId, selectedSims])

    const handleChiudiClick = () => {
        handleDialogClose()
        dispatch(resetReportResponse());
    }

    const handleContinueFirstStep = () => {
        const selectedPlan = planOptions.find(p => p.id === values.planType)
        if (selectedPlan?.qtaDisponibile < selectedSims.length) {
            /*toastError("Hai selezionato un numero di SIM superiore alla quantità disponibile per questa offerta\n" +
                "Seleziona un piano con disponibilità compatibile, oppure seleziona un numero inferiore di SIM")*/
            setQtaSuperataOpen(true)
            return
        }
        handleSetStep(1)
    }

    const steps = {
        0: {
            component: <ActivationRequestStep
                values={values}
                setValues={setValues}
                selectedSims={selectedSims}/>,
            componentActions: <ActivationRequestStepActions
                step={step}
                handleDialogClose={handleDialogClose}
                onConfermaClick={handleContinueFirstStep}
                isButtonDisabled={values.serviceType === '' || values.planType === ''}/>,
            title: `Richiesta attivazione per ${selectedSims.length} SIM`,
            width: 'md'
        },
        1: {
            component: <ActivationSummaryStep
                selectedValues={values}/>,
            componentActions: <ActivationRequestStepActions step={step}
                                                            setStep={setStep}
                                                            selectedValues={values}
                                                            selectedSims={selectedSims}
                                                            handleStepBack={() => handleSetStep(0)}/>,
            title: `Richiesta attivazione per ${selectedSims.length} SIM`,
            width: 'md'
        },
        2: {
            component: <ActivationConfirmStep/>,
            componentActions: <ActivationConfirmStepAction
                                    onClick={handleChiudiClick}/>,
            title: 'Riepilogo della tua richiesta di attivazione',
            width: 'sm',
            handleDialogClose: handleChiudiClick,
            handleDialogCloseButton: handleChiudiClick,
        }
    }

    return (
        <GenericDialog dialogWidth={steps[step].width}
                       dialogContent={steps[step].component}
                       dialogActions={steps[step].componentActions}
                       open={open}
                       handleDialogClose={steps[step].handleDialogClose ?? handleDialogClose}
                       handleDialogCloseButton={steps[step].handleDialogCloseButton ?? handleDialogClose}
                       loading={false}>
            <Typography variant={"h5"}>{steps[step].title}</Typography>
            {qtaSuperataOpen ? <QuantitaSuperataDialog open={qtaSuperataOpen}
                                                       handleDialogClose={() => setQtaSuperataOpen(false)}/> : null}
        </GenericDialog>
    )
}

AttivaSimDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired,
}

export {AttivaSimDialog}
